import {useIsLargeDevice, useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Box, Typography} from '@mui/material';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import MembershipFeatures from './MembershipFeatures';

type MembershipFeaturesSectionProps = {
  queryParams: {
    recappid?: string;
    refcode?: string;
    pageid?: string;
  };
};


const MembershipFeaturesSection = ({ queryParams }: MembershipFeaturesSectionProps) => {
  const theme = useWrappedTheme();

  const interceptor: any = useInterceptor();
  const {
    proMembership: {planPopUp},
  } = interceptor;

  return (
    <Box sx={{marginLeft: {xs:1, md:3}, marginRight: {xs:1, md:3}, marginBottom: 3}}>
      <Box sx={{textAlign: 'center'}}>
        <Typography
          gutterBottom
          component="div"
          sx={{
            color: 'secondary.dark',
            fontSize: {
              xs: theme.typography.pxToRem(18),
              md: theme.typography.pxToRem(24),
            },
            fontWeight: 600,
          }}
        >
          What you will get in{' '}
          <Typography
            component="span"
            sx={{
              fontSize: {
                xs: theme.typography.pxToRem(18),
                md: theme.typography.pxToRem(24),
              },
              fontWeight: 600,
              background: theme.palette.pro.main,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Pro Membership
          </Typography>
        </Typography>
        <Typography
          gutterBottom
          component="div"
          sx={{
            color: 'secondary.dark',
            fontSize: {
              xs: theme.typography.pxToRem(14),
              md: theme.typography.pxToRem(18),
            },
            fontWeight: 400,
            lineHeight: {xs: '18px', md: '20px'},
            marginBottom: 5,
          }}
        >
          Upgrade to the Pro Membership Plan & Enhance your Job Search
        </Typography>
      </Box>
      <MembershipFeatures planPopUp={planPopUp} source="membership-page" queryParams={queryParams}/>
    </Box>
  );
};

export default MembershipFeaturesSection;
